import { call, put, takeLatest } from 'redux-saga/effects';
import { thongKeApi } from '../../../api/thongKeApi';
import { IThongKeSiSoSelectRequest } from '../../../models/request/thong-ke/IThongKeSiSoSelectRequest';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { eThongKeCSKHActionTypeIds, IThongKeCSKHActionTypes } from '../../action-types/thong-ke/IThongKeCSKHActions';
import { actions } from '../../actions/actionsWrapper';
const mainAction = actions.thongKe.thongKeCSKH;

export function* thongKeCSKHSaga(): any {
    yield takeLatest(eThongKeCSKHActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eThongKeCSKHActionTypeIds.LOAD_BY_MONTH_START, loadByMonthWorker)

}

function* loadWorker(action: IThongKeCSKHActionTypes): any {
    const res: IBaseResponeModel = yield call(thongKeApi.ThongKeCSKH, action.payload as IThongKeSiSoSelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Error"))
    }
}


function* loadByMonthWorker(action: IThongKeCSKHActionTypes): any {
    const res: IBaseResponeModel = yield call(thongKeApi.ThongKeCSKHByMonth, action.payload as IThongKeSiSoSelectRequest)
    if (res.is_success) {
        yield put(mainAction.LOAD_BY_MONTH_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_BY_MONTH_ERROR(res.message ?? "Error"))
    }
}
